import {
  Buildings,
  MapPin,
  User,
  CheckCircle,
  Stethoscope,
} from '@phosphor-icons/react';

export const TAXONOMY_CODES = [
  { value: '251E00000X', label: '251E00000X - Home Health Aide' },
  { value: '251B00000X', label: '251B00000X - Home Health' },
  { value: '251K00000X', label: '251K00000X - Public Health/Community' },
  { value: '261QM0850X', label: '261QM0850X - Adult Mental Health' },
  { value: '171100000X', label: '171100000X - Acupuncturist' },
  { value: 'other', label: 'Other (enter manually)' },
];

export const STEPS = [
  { id: 1, title: 'Agency Info', icon: Buildings },
  { id: 2, title: 'Sandata EVV', icon: Stethoscope },
  { id: 3, title: 'Address & Contact', icon: MapPin },
  { id: 4, title: 'Admin Account', icon: User },
  { id: 5, title: 'Review', icon: CheckCircle },
];

export const INITIAL_FORM = {
  agency_name: '', dba_name: '', npi: '', tax_id: '',
  medicaid_provider_id: '', taxonomy_code: '', taxonomy_other: '',
  sandata_provider_id: '', sandata_provider_code: '', sandata_medicaid_id: '',
  sandata_api_username: '', sandata_api_password: '',
  street1: '', street2: '', city: '', state: 'OH', zip_code: '', county: '',
  contact_name: '', contact_title: '', contact_phone: '', contact_email: '', contact_fax: '',
  admin_name: '', admin_email: '', admin_password: '', admin_password_confirm: '',
};
